define('get-answer-prop',['exports'], function (exports) {
   'use strict';

   Object.defineProperty(exports, "__esModule", {
      value: true
   });

   exports.default = function (answers, prop, key, value) {
      return Array.isArray(answers) && typeof prop === 'string' && prop && typeof key === 'string' && key && typeof value === 'string' && value ? answers.filter(function (answer) {
         return answer[key] === value;
      }).reduce(function (res, o) {
         return o[prop] || res;
      }, '') : '';
   };
});
